// Author handle + x.com URL rendered in the `AUTHOR` section of every route.

export const AUTHOR_HANDLE = '@PilsnerChamp';

export const AUTHOR_X_URL = 'https://x.com/PilsnerChamp';
